import { render } from "./ProductVariants.vue?vue&type=template&id=ecb4fb2c&ts=true"
import script from "./ProductVariants.vue?vue&type=script&lang=ts"
export * from "./ProductVariants.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__